import React, { useEffect } from "react";
import { useContext } from "react";

import { useMeetingManager, useRosterState } from "amazon-chime-sdk-component-library-react";

import { MeetingInfoContext } from "../../../../../context";

import SelectedVideoTileGrid from "./components/selected-video-grid";

interface FilteredVideoTileGridProps {
  viewHeight: number;
  viewWidth: number;
  showNamePlate: boolean;
  excludeSelf: boolean;
}

export const FilteredVideoTileGrid: React.FC<FilteredVideoTileGridProps> = ({
  viewHeight,
  viewWidth,
  showNamePlate,
  excludeSelf,
}) => {

  const { roster } = useRosterState();
  const meetingManager = useMeetingManager();
  const { selectedAttendees, setSelectedAttendees, userId, otherAttendees, setOtherAttendees } = useContext(MeetingInfoContext);

  const myExternalId = meetingManager?.meetingSession?.configuration.credentials?.externalUserId;

  useEffect(() => {
    const newOtherAttendees: string[] = [];
    const newToSetOtherAttendees: string[] = [];

    for (const attendeeId in roster) {

      if (!roster[attendeeId]) {
        continue;
      }

      if (!roster[attendeeId].externalUserId) {
        continue;
      }

      const currentAttendee: any = roster[attendeeId];

      let id = currentAttendee?.actualUserId;

      if (!id) {
        continue;
      }

      if (id == userId && excludeSelf) {
        continue;
      }

      if (myExternalId && currentAttendee.externalUserId == myExternalId) {
        continue;
      }

      newOtherAttendees.push(attendeeId);

      if (!selectedAttendees.includes(attendeeId) && otherAttendees.includes(attendeeId)) {
        continue;
      }

      newToSetOtherAttendees.push(attendeeId);
    }

    if (!twoListsAreTheSame(newOtherAttendees, otherAttendees)) {
      setOtherAttendees(newOtherAttendees);
    }

    if (!twoListsAreTheSame(newToSetOtherAttendees, selectedAttendees)) {
      setSelectedAttendees(newToSetOtherAttendees);
    }

  }, [roster, userId, selectedAttendees]);

  const twoListsAreTheSame = (first: string[], second: string[]) => {
    if (first.length != second.length) {
      return false;
    }

    for (let i = 0; i < first.length; i++) {
      if (first[i] != second[i]) {
        return false;
      }
    }

    return true;
  }

  return (
    <SelectedVideoTileGrid
      tilesToShow={selectedAttendees}
      showNamePlate={showNamePlate}
      viewHeight={viewHeight}
      viewWidth={viewWidth} />
  );
};

export default FilteredVideoTileGrid;